import { IressPanel, IressStack, IressText } from '@iress-oss/ids-components';
import { ReactNode } from 'react';

import { EntityDetailsDisplay } from './EntityDetailsDisplay';
import { EntityDetailsLoader } from './EntityDetailsLoader';
import { LoadingAndErrorHandler } from '../LoadingAndErrorHandler/LoadingAndErrorHandler';

export const EntityDetails = (): ReactNode => (
    <IressPanel background="page" padding="none" data-testid="entity-details">
        <IressStack gutter="none">
            <LoadingAndErrorHandler
                LoadingComponentFallback={<EntityDetailsLoader />}
                ErrorComponentFallback={
                    <IressText variant="display4" data-testid="entity-details__error">
                        Unable to load entity details
                    </IressText>
                }
            >
                <EntityDetailsDisplay />
            </LoadingAndErrorHandler>
        </IressStack>
    </IressPanel>
);
